// Copyright (c) 2022 by Move Closer

import { AppModule, Container, IConfiguration, IModal, Interfaces, ModalType, Module } from '@movecloser/front-core'

import { DrawerType, IDrawer } from '../shared/contracts/services'
import { GraphQlConnectorType, IGraphQL } from '../../contexts'

import { IProductsRepository, ProductsRepositoryType } from '../products/contracts/repositories'

import { checkoutQueries, drawersRegistry, modalsRegistry } from './config'
import { checkoutRoutes as routes } from './routes'
import { CartService, CartServiceType, ICartService } from './services/cart'
import { CheckoutService, CheckoutServiceType, ICheckoutService } from './services/checkout'
import { storeFactory as state } from './store'

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl> (original)
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl> (edited)
 */
@AppModule({
  name: 'checkout',
  providers: () => (bind: Interfaces.Bind) => {
    bind<ICartService>(CartServiceType).toDynamicValue(context => {
      return new CartService(
        context.container.get<IGraphQL>(GraphQlConnectorType),
        context.container.get<IProductsRepository>(ProductsRepositoryType)
      )
    }).inSingletonScope()

    bind<ICheckoutService>(CheckoutServiceType).toDynamicValue(context => {
      return new CheckoutService(
        context.container.get<IGraphQL>(GraphQlConnectorType),
        context.container.get<IProductsRepository>(ProductsRepositoryType)
      )
    }).inSingletonScope()
  },
  boot (container: Container, config: IConfiguration) {
    const modalConnector = container.get<IModal>(ModalType)
    modalConnector.register(modalsRegistry)

    const drawerConnector = container.get<IDrawer>(DrawerType)
    drawerConnector.register(drawersRegistry)

    const graph = container.get<IGraphQL>(GraphQlConnectorType)
    graph.useQueries(checkoutQueries(config))
  },
  routes,
  state
})

export class CheckoutModule extends Module {}
